/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Stage_Learn_DescInputs */

const en_directory_detail_signals_ai_stage_learn_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Learn_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs, quickstart, API reference, OpenAPI spec, request and response examples, error semantics.`)
};

const zh_directory_detail_signals_ai_stage_learn_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Learn_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档、快速上手、API 参考、OpenAPI 规范、请求/响应示例、错误语义。`)
};

/**
* | output |
* | --- |
* | "Docs, quickstart, API reference, OpenAPI spec, request and response examples, error semantics." |
*
* @param {Directory_Detail_Signals_Ai_Stage_Learn_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_stage_learn_desc = /** @type {((inputs?: Directory_Detail_Signals_Ai_Stage_Learn_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Stage_Learn_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_stage_learn_desc(inputs)
	return zh_directory_detail_signals_ai_stage_learn_desc(inputs)
});
export { directory_detail_signals_ai_stage_learn_desc as "directory.detail.signals.ai_stage.learn_desc" }